import Button from '@ui/buttons/Button'
import Popover from '@ui/components/Popover'
import Glass from '@ui/elements/Glass'
import AppConfig from 'config'
import { useState } from 'react'
import { Platform, View } from 'react-native'
import { useSharedValue } from 'react-native-reanimated'
import {
  useDebugPanelStore,
  useRegisteredDebugModals,
} from './useDebugPanelStore'

interface Props {
  onOpen?: () => void
}

function DebugPanelButtonInner({ onOpen }: Props) {
  const debugModals = useRegisteredDebugModals()
  const openDebugModal = useDebugPanelStore((s) => s.open)
  const [pickerOpen, setPickerOpen] = useState(false)
  const popoverWidth = useSharedValue(200)

  if (debugModals.length === 0) return null

  if (debugModals.length === 1) {
    return (
      <Button
        variant="outlined"
        icon="start"
        size="xs"
        iconStart="bug"
        onPress={() => {
          onOpen?.()
          openDebugModal(debugModals[0].key)
        }}
      />
    )
  }

  return (
    <Popover
      open={pickerOpen}
      onClose={() => setPickerOpen(false)}
      position={['top', 'right']}
      offset={[1, 8]}
      customWidth={popoverWidth}
      content={
        <Glass
          blur={50}
          className="flex w-full flex-col rounded-2xl border border-black/10 bg-white/50"
        >
          {Platform.OS === 'web' && (
            <div className="absolute left-0 top-0 h-full w-full rounded-2xl backdrop-blur-2xl" />
          )}
          <View className="flex min-w-[180px] flex-col gap-2 p-4">
            {debugModals.map((modal) => (
              <Button
                key={modal.key}
                variant="outlined"
                size="xs"
                icon="start"
                iconStart="bug"
                label={modal.label}
                onPress={() => {
                  setPickerOpen(false)
                  onOpen?.()
                  openDebugModal(modal.key)
                }}
              />
            ))}
          </View>
        </Glass>
      }
    >
      <Button
        variant="outlined"
        icon="start"
        size="xs"
        iconStart="bug"
        onPress={() => setPickerOpen(true)}
      />
    </Popover>
  )
}

export default function DebugPanelButton(props: Props) {
  if (!AppConfig.isDev) return null
  return <DebugPanelButtonInner {...props} />
}
